// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn[data-v-7b2608db]{\n  margin: 10px;\n  color: white;\n}\n", ""]);
// Exports
module.exports = exports;
